<template>
  <div class="chat-input">
    <div class="input-label" v-if="!!label">{{label}}：</div>
    <div class="form-input">
      <input type="text" :value="value" @input="onInput" :readOnly="readonly" :placeholder="placeholder">
      <slot name="right-icon" />
    </div>
  </div>
</template>

<script>
export default {
  props:{
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '在这里输入内容'
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value)
    }
  }
}
</script>

<style scoped lang="scss">
.chat-input {
  display: flex;
  align-items: center;
}
.form-input {
  flex: 1;
  position: relative;
  width: 100%;
  display: flex;
  padding: 5px 3px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  align-items: center;
  input {
    flex: 1;
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
    width: 100%;
    border: none;
    padding: 0 4px;
    box-sizing: border-box;
    caret-color: rgba(0, 122, 255, 1);
  }
}
// .form-input:after {
//   content: "";
//   position: absolute;
//   top: 50%;
//   left: 4px;
//   height: 14px;
//   width: 1px;
//   background-color: rgba(0, 122, 255, 1);
//   transform: translateY(-50%);
// }
.input-label{
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  text-align: left;
  vertical-align: top;
}
</style>